module.exports = __webpack_public_path__ + "media/site/images/app-preview/mobile-screen-9ceb64c097756dd531d9350edcd2bb8e.png";